import { createContext, useContext, useEffect, useId } from 'react';

/**
 * Canvis pendents d'Ajustos. Cada pantalla d'edició declara quants canvis té sense desar
 * (`BarraCanvis` o `useCanvisPendents`); abans de navegar o de canviar l'element seleccionat
 * es crida `useGuardaCanvis()(accio)`, que demana confirmació si cal (`CanvisProvider`).
 */
export interface ContextCanvis {
  pendents: boolean;
  registra: (id: string, n: number) => void;
  demana: (accio: () => void) => void;
}

export const CanvisCtx = createContext<ContextCanvis>({
  pendents: false,
  registra: () => undefined,
  demana: (accio) => accio(),
});

/** Declara `n` canvis pendents mentre el component és muntat. */
export function useCanvisPendents(n: number) {
  const id = useId();
  const { registra } = useContext(CanvisCtx);
  useEffect(() => {
    registra(id, n);
  }, [id, n, registra]);
  useEffect(() => () => registra(id, 0), [id, registra]);
}

/** Executa una acció (navegar, canviar de selecció) demanant confirmació si hi ha canvis. */
export function useGuardaCanvis() {
  return useContext(CanvisCtx).demana;
}

export function useHiHaCanvis() {
  return useContext(CanvisCtx).pendents;
}
